export const productIds = (env = 'production') => ({
  enterprise: env === 'production' ? 'prod_QkFgAzO61B9FfB' : 'prod_Qh4UwgrjLtx68m',
  professional: env === 'production' ? 'prod_QkFgJvRlfygTGR' : 'prod_Qh4FaJIbCl1ihc'
});
